var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaborGroups = function SvgLaborGroups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29 10A7.015 7.015 0 0 1 10 5.29M5.29 14A7.015 7.015 0 0 0 10 18.71m4 0A7.015 7.015 0 0 0 18.71 14m0-4A7.016 7.016 0 0 0 14 5.29",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgLaborGroups;